import { getConfig } from '@cian/config/browser';

import { createStore, IAppState, IContext } from '../../../shared/store';

export function createAppState(context: IContext) {
  const config = getConfig();

  const defaultState = config.get<IAppState>('defaultState');

  return createStore(context, defaultState as IAppState);
}
